export default __webpack_public_path__ + "static/media/non_avatar.b001d7f8.png";